import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AuthProvider, EntitlementsProvider } from "@cloudox/api-client";
import { createPreviewKnowledgeProvider } from "@/lib/knowledge";
import "./styles/app.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container '#root' not found in index.html");
}

const provider = createPreviewKnowledgeProvider();

createRoot(container).render(
  <StrictMode>
    <AuthProvider>
      <EntitlementsProvider>
        <App provider={provider} />
      </EntitlementsProvider>
    </AuthProvider>
  </StrictMode>,
);
